import axios from 'axios';

export const fetcher = (url: string, headers: any={}) => axios.get(url, headers).then((res: any) => res.data)

export const runtime = typeof process === 'undefined' ? 'bun' : 'node'

export const host = runtime == 'node' ? process?.env?.NEXT_PUBLIC_HOST_API : location?.origin

export const ella = runtime == 'node' ? process?.env?.NEXT_PUBLIC_OID_PROVIDER_API : 'https://uporabnik.delo.si'

export function wait(milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
}

export const isImage = (url: string|null) => {
    if(!url) return false
    return /\.(jpg|jpeg|png|webp|avif|gif|svg|JPG|JPEG|PNG|WEBP|AVIF|GIF|SVG)$/.test(url);
};